<template>
  <div
    class="sand-page"
    @touchstart="touchStart"
    @touchmove="touchMove"
  >
    <div
      id="vtourSand"
      class="vtour-view"
    />
    <!-- 免责声明 -->
    <disclaimer
      class="disclaimer"
      :options="options"
    />
    <!-- 滑动器 -->
    <accord-menu
      class="menu-view"
      :tag-info="SAND_TAG_INFO"
      :info="accordInfo"
      :value="selectAccord"
      :group="group"
      :show-tag="showTag"
      @onChange="onChangeAccord"
      @onChangeGroup="onChangeGroup"
    />
  </div>
</template>

<script>
import AccordMenu from '@/components/index/AccordMenu';
import Disclaimer from '@/components/Disclaimer';
import { ACCORD_INFO_SAND, SAND_TAG_INFO } from '@/libs/config/tour';
import { getIsFirstOpen } from '@/libs/util';

export default {
  components: {
    AccordMenu,
    Disclaimer,
  },
  props: {
    version: {
      type: String,
      default: 'v0',
    },
  },
  data() {
    return {
      SAND_TAG_INFO,
      showTag: true,
      group: 10,
      selectAccord: '01',
      accordInfo: ACCORD_INFO_SAND,
      offRotate: 0,
      options: {
        isFirstOpen: getIsFirstOpen(),
      },
    };
  },
  mounted() {
    console.log();
    window.embedpano({
      // swf: 'https://outsourcing.obs.cn-south-1.myhuaweicloud.com/xukebao/vanke/vtour_78/tour.swf',
      // xml: `https://outsourcing.obs.cn-south-1.myhuaweicloud.com/xukebao/vanke/vtour_78/tour.xml?v=${this.version}`,
      xml: './vtour_sand/tour.xml?version=3.2',
      swf: './vtour_sand/tour.swf',
      target: 'vtourSand', // DOM节点id
      id: 'sand',
      html5: 'only',
      onready: this.krpano_onready_callback,
    });
    this.si = setInterval(() => {
      if (this.krpano) {
        const sceneName = this.krpano.get('xml.scene');
        if (!sceneName) {
          return;
        }
        const num = sceneName.replace(/[^\d.]/g, '');
        if (num === this.selectAccord) {
          return;
        }
        this.onChangeAccord(num);
      }
    }, 500);
  },
  destroyed() {
    if (this.si) {
      clearInterval(this.si);
    }
  },
  methods: {
    // 路由携带参数跳转指定场景
    initScene() {
      const { id = '' } = this.$route.query;
      if (id) {
        this.krpano.call(`loadscene('scene_${id}', null, null, BLEND(1))`);
      }
    },
    krpano_onready_callback(krpanoInterface) {
      this.krpano = krpanoInterface;
      this.initScene();
    },
    onChangeAccord(id) {
      this.offRotate = 0;
      this.selectAccord = id;
      this.showTag = id === '01';
      this.krpano.call(`loadscene('scene_${id}', null, null, BLEND(1))`);
      if (this.showTag) {
        this.krpano.call(`set_hotspot_visible("${false}");`);
        this.onChangeGroup(this.group);
      } else {
        this.krpano.call(`set_hotspot_visible("${true}");`);
      }
    },
    touchStart() {
      this.startX = this.krpano.get('view.hlookat');
    },

    touchMove() {
      const endX = this.krpano.get('view.hlookat');
      this.offRotate += endX - this.startX;
      this.startX = endX;
    },
    onChangeGroup(group) {
      this.group = group;
      // 隐藏详情
      this.krpano.call('set_hotspot_visible(true);');
      this.krpano.call('hotspot_fun_detail_hide(27)');
      if (group === 0) {
        console.log('test');
        // this.krpano.call(`hotspot_fun_group_show("${0}")`);
        return;
      }
      this.krpano.call(`hotspot_fun_group_show("${group}")`);
      if (group === 1) {
        this.krpano.call(`lookto(${-11}, ${19});zoomto(96.546)`);
      }
      if (group === 2) {
        this.krpano.call(`lookto(${-8}, ${13});zoomto(96.546)`); // (h, v)
        // 显示详情
        this.krpano.call('hotspot_fun_detail_show(27)');
      }
      if (group === 3) {
        this.krpano.call(`lookto(${0}, ${30});zoomto(70)`);
      }
      if (group === 4) {
        this.krpano.call(`lookto(${0}, ${16});zoomto(96.546)`);
      }
      if (group === 5) {
        this.krpano.call(`lookto(${-28}, ${24});zoomto(96.546)`);
      }
      if (group === 6) {
        this.krpano.call(`lookto(${18}, ${30});zoomto(96.546)`);
      }
      if (group === 10) {
        this.krpano.call(`set_hotspot_visible("${false}");zoomto(96.546)`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sand-page {
  width: 10rem;
  height: calc(100vh - 54px);
  .drop-pos {
    position: absolute;
    z-index: 20;
    left: .2rem;
    top: 30px;
    // width: 180px;
  }
  .compass {
    position: absolute;
    z-index: 11;
    right: 0.5rem;
    bottom: calc(4vh + 60px);
  }
  .disclaimer {
    position: absolute;
    z-index: 100;
    right: 10px;
    bottom: 175px;
  }
  .menu-view {
    position: absolute;
    z-index: 11;
    left: 0;
    bottom: 54px;
  }
  .tag-view {
    position: absolute;
    z-index: 11;
    left: 0;
    // bottom: calc(20vh + 60px);
    top: calc(65vh - 60px);
    animation: fade-ani 1s linear;
    .tag {
      min-width: 71px;
      height: 24px;
      margin-bottom: 5px;
      padding: 0 5px 1px 2px;
      box-sizing: border-box;
      background: #000000;
      opacity: 0.72;
      font-size: 10px;
      font-weight: normal;
      color: #e6e6e6;
      border-radius: 0px 10px 10px 0px;
      border: 0.5px solid #cda36e;
    }
    .select-tag {
      opacity: 1;
      color: #000000;
      background: rgba(205, 163, 110, 0.9);
      border: 0.5px solid #edc28b;
    }
  }
}
</style>
